import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgErrorCircleSmall } from './svg/error-circle-small.svg.js';

/**
 * @deprecated - use AlertCircle.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const ErrorCircleSmall = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgErrorCircleSmall, { viewBox: "-6 -6 36 36", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "ErrorCircleSmall" }));
};

export { ErrorCircleSmall as default };
//# sourceMappingURL=ErrorCircleSmall.js.map
